// export const isAuthenticatedSelector = (state) => state.auth.isAuthenticated;
// export const sessionIdSelector = (state) => state.auth.sessionId;

export const selectSessionIdAuth = (state) => state.auth.sessionId;
// export const selectTokenAuth = (state) => state.auth.token;

// export const selectIsErrorAuth = (state) => state.auth.error;
// export const selectLoadingAuth = (state) => state.auth.loading;
